import React, { useState } from "react";
import { makeStyles, Collapse, Typography, ListItem, ListItemText, useMediaQuery, useTheme } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import FunnelSummaryCard from "./FunnelSummaryCard";
import useCart from "hooks/useCart";
import { getCartPrice } from "../utils";
import { formatPriceCents } from "components/product/utils";
import BackgroundPoints from "../assets/backgroundPoints.svg";

export default function FunnelStepTemplate({ children, hideRecap, initialCart }) {
  const classes = useStyle();
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);
  const [cart] = useCart();
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));
  if (isTablet) {
    return (
      <>
        {!hideRecap && (
          <>
            <div className={classes.inner}>
              <ListItem button disableGutters onClick={() => setExpanded((prev) => !prev)} className={classes.listItem}>
                <ListItemText
                  primary="Votre commande"
                  secondary={
                    <div className={classes.inline}>
                      <Typography variant="body2" className={classes.greyText} component="span">
                        Voir le détail
                      </Typography>
                      <ExpandMoreIcon className={`${classes.icon} ${expanded ? classes.rotateIcon : null}`} />
                    </div>
                  }
                />
                <div className={classes.price}>{formatPriceCents(getCartPrice(cart))}</div>
              </ListItem>
              <Collapse in={expanded} className={classes.expandablePanel}>
                <FunnelSummaryCard initialCart={initialCart} />
              </Collapse>
            </div>
            <div className={classes.divider} />
          </>
        )}
        <div className={classes.inner}>{children}</div>
      </>
    );
  }
  return (
    <div className={classes.container}>
      <BackgroundPoints className={classes.shape} />
      {children}
      {!hideRecap && <FunnelSummaryCard initialCart={initialCart} />}
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  listItem: {
    alignItems: "flex-start",
    padding: 0,
    "& .MuiListItemText-root": {
      marginTop: 0,
      "& .MuiListItemText-primary ": {
        fontWeight: 500,
      },
    },
  },
  shape: {
    position: "absolute",
    left: 0,
    width: "calc(50vw - 480px)",
    top: 0,
    zIndex: -1,
  },
  divider: {
    marginBottom: theme.spacing(6),
    backgroundColor: "#DBDFE8",
    height: 1,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
    },
  },
  greyText: {
    color: theme.palette.text.disabled,
  },
  inline: {
    display: "flex",
    alignItems: "center",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    gridColumnGap: theme.spacing(8),
    gridRowGap: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(8),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  reacpHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  expandablePanel: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  inner: {
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  icon: {
    color: theme.palette.text.disabled,
    transition: "all 0.2s ease",
    marginLeft: theme.spacing(),
  },
  rotateIcon: {
    transform: "rotateZ(180deg)",
  },
  price: {
    fontWeight: 500,
    fontSize: 20,
  },
}));
